import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost/api'

export const downloadSubprojectAll = (request) => {
  // http://localhost/api/files/download/search-subproject/all
  const url = `${API_ROOT}/files/download/search-subproject/all`
  return doPostDownload(url, request)
}

export const getSubprojectAll = (pageSize = 5, pageNumber = 1) => {
  // http://localhost/api/subproject/search-subproject/5/page/1
  const url = `${API_ROOT}/subproject/search-subproject/${pageSize}/page/${pageNumber}`
  return doGet(url)
}

export const searchSubprojectAll = (pageSize = 5, pageNumber = 1, request) => {
  // http://localhost/api/subproject/search-subproject/5/all/1
  const url = `${API_ROOT}/subproject/search-subproject/${pageSize}/all/${pageNumber}`
  return doPost(url, request)
}
